import api from "../api";

export const useBuyPropertyToken = (data) => {
  const { id, ...data2 } = data;

  return api
    .post(`/property/${id}/create-order`, data2)
    .then((res) => res.data);
};
